$(document).ready(function() {
  if($('body').hasClass('template-product')) {
    var getProductJson = JSON.parse($('.productJson').html());
    // 修改排序
    let variants = getProductJson.variants
    console.log(variants)
    let eqV = ""
    let defaultId = getParam("variant")
    let sortColumn = []
    let variantsTmp = {}
    for (let i=0;i<variants.length;i++){
      if(defaultId == variants[i].id){
        eqV = variants[i].option1
      }
      if(variantsTmp.name){
        if(variantsTmp.name === variants[i].option1){
          variantsTmp.num += variants[i].available ? 1 : 0
        }else {
          if(variantsTmp["num"] > 0) sortColumn.push(variantsTmp)
          variantsTmp = {
            name: variants[i].option1,
            num: variants[i].available?1:0
          }
        }
      }else {
        variantsTmp = {
          name: variants[i].option1,
          num: variants[i].available?1:0
        }
      }
    }
    if(variantsTmp["num"] > 0) sortColumn.push(variantsTmp)
    sortColumn.sort((a, b)=> {return b.num - a.num})
    let hasEqV = false
    for(let i=0; i<sortColumn.length;i++){
      if(sortColumn[i].name == eqV){
        hasEqV = true
        break
      }
    }
    if(hasEqV == false) eqV = ""

    let dom = $(".variant-input-wrap[data-index='option1']")[0].getElementsByTagName("div")
    let newHtml = sortColumn.map(column => {
      let item
      let name = $.trim(column.name)
      for(let i=0;i<dom.length;i++){
        if(name === $.trim(dom[i].textContent)){
          item = dom[i]
          if(eqV === "") eqV = $.trim(column.name)
          break
        }
      }
      return item
    })
    if(newHtml.length > 0){
      $(".variant-input-wrap[data-index='option1']")[0].innerHTML = `<legend class="hide">${getProductJson.options[0]}</legend>`
      newHtml.forEach(item=> {
        $(".variant-input-wrap[data-index='option1']")[0].append(item)
      })
    }

    var optionArr = [];
    // var findInitialValue = $('[name="Color"]:checked').val();
    var findInitialValue = newHtml.length > 0 ? eqV :$('[name="Color"]:checked').val();
    $('div[data-index="option1"] label').on('click', function() {
      optionArr = [];
      $('input[data-index="option1"], [data-index="option2"]').removeClass('outOfStock');
      $('input[data-index="option1"], [data-index="option2"]').parent().removeClass('sold_out');
      var getSelectedVal = $(this).siblings().val();
      var getDataIndex = $(this).siblings().attr('data-index');
      var getDataIndexVal = (getDataIndex == 'option1')? 'option2' : 'option1';
      $('input[data-index="'+getDataIndexVal+'"]').addClass('outOfStock');
      $('input[data-index="'+getDataIndexVal+'"]').parent().addClass('sold_out');
      $.each(getProductJson.variants,function(i,v){
        if(optionArr.indexOf(v[getDataIndexVal]) < 0 && v.available && getSelectedVal == v[getDataIndex]) {
          	$('input[value="'+v[getDataIndexVal]+'"]').removeClass('outOfStock');
          	$('input[value="'+v[getDataIndexVal]+'"]').parent().removeClass('sold_out');
        	optionArr.push(v[getDataIndexVal]);
        }
      });
    });
    $('input[value="'+findInitialValue+'"]').siblings('label').trigger('click');
  }
});

function getParam(variable = ""){
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i=0;i<vars.length;i++) {
    var pair = vars[i].split("=");
    if(pair[0] == variable){return pair[1];}
  }
  return(false);
}